// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-comment-input[data-v-d67161be]{margin-bottom:1rem}`, "",{"version":3,"sources":["webpack://./vue/components/ckeditor/add-comment-input.vue"],"names":[],"mappings":"AACA,oCACI,kBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
